export const NOTIFICATION_PANEL_CLASS = 'border-border bg-card text-card-foreground';
export const NOTIFICATION_HEADER_BORDER_CLASS = 'border-border';
export const NOTIFICATION_FILTER_BAR_CLASS = 'border-border bg-muted/40';
export const NOTIFICATION_DIVIDER_CLASS = 'divide-border';

export const NOTIFICATION_MUTED_TEXT_CLASS = 'text-muted-foreground';
export const NOTIFICATION_TIMESTAMP_CLASS = 'text-muted-foreground/80';

export const NOTIFICATION_ITEM_CLASS =
  'cursor-pointer p-4 transition-colors hover:bg-accent/40';
export const NOTIFICATION_ITEM_UNREAD_CLASS = 'bg-primary/10';
export const NOTIFICATION_ITEM_READ_CLASS = '';
export const NOTIFICATION_ITEM_TITLE_UNREAD_CLASS = 'text-foreground';
export const NOTIFICATION_ITEM_TITLE_READ_CLASS = 'text-foreground/80';
export const NOTIFICATION_ITEM_MESSAGE_UNREAD_CLASS = 'text-foreground/85';
export const NOTIFICATION_ITEM_MESSAGE_READ_CLASS = 'text-muted-foreground';
export const NOTIFICATION_UNREAD_DOT_CLASS = 'h-2 w-2 rounded-full bg-primary';
export const NOTIFICATION_DISMISS_BUTTON_CLASS =
  'h-7 text-xs text-muted-foreground hover:text-destructive';

export const NOTIFICATION_DROPDOWN_CONTENT_CLASS =
  'w-80 border-border bg-popover text-popover-foreground';
export const NOTIFICATION_DROPDOWN_EMPTY_CLASS =
  'p-4 text-center text-sm text-muted-foreground';
export const NOTIFICATION_DROPDOWN_ITEM_CLASS =
  'flex cursor-pointer flex-col items-start gap-1 rounded-md p-3';
export const NOTIFICATION_DROPDOWN_ITEM_UNREAD_CLASS = 'bg-primary/10';
export const NOTIFICATION_DROPDOWN_MESSAGE_CLASS = 'text-xs text-muted-foreground';
export const NOTIFICATION_DROPDOWN_TIMESTAMP_CLASS = 'mt-1 text-xs text-muted-foreground/80';